import React, { useContext } from "react";
import "./ModelsDropdown.css";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";

import freeImg from "../../assets/images/dropdown/voyahFree.webp";
import dreamImg from "../../assets/images/dropdown/voyahDream.webp";
import taishan from "../../assets/images/dropdown/taishan.png";

const ModelsDropdown = ({ onClose }) => {
  const { texts } = useContext(LanguageContext);
  const t = texts.navbar || {};

  return (
    <div
      className="models-dropdown no-rtl"
      onMouseLeave={onClose}
      onMouseEnter={() => {}}
    >
      <div className="models-container">
        <div className="model-card">
          <img src={freeImg} alt={t.voyahFree} />
          <h3>{t.voyahFree}</h3>

          <div className="model-links">
            <Link className="cyan" to="/voyah-free">
              {t.findOutMore}
            </Link>
            <Link to="/voyah-free-build">{t.buildYourCar}</Link>
          </div>
        </div>

        <div className="model-card">
          <img src={dreamImg} alt={t.voyahDream} />
          <h3>{t.voyahDream}</h3>

          <div className="model-links">
            <Link className="cyan" to="/voyah-dream">
              {t.findOutMore}
            </Link>
            <Link to="/voyah-dream-build">{t.buildYourCar}</Link>
          </div>
        </div>

        <div className="model-card">
          <img src={taishan} alt={t.voyahTaishan} />
          <h3>{t.voyahTaishan}</h3>

          <div className="model-links">
            <Link className="cyan" to="/voyah-taishan">
              {t.findOutMore}
            </Link>
            <Link to="/voyah-taishan-build">{t.buildYourCar}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModelsDropdown;
